export default __webpack_public_path__ + "static/media/MeerkatsCh3.9cb79906.svg";